<div
    [ngClass]="{'hidden': !darkMode }"
    class="dark-globe"
    (pointerdown)="pause()"
    (pointerup)="start()"
    #divGlobe
    id="mapdiv">
</div>
<div *ngIf="!darkMode" class="blue-container">
    <div class="stars"></div>
    <div class="stars2"></div>
    <div class="stars3"></div>
    <div class="planet-container">
        <img class="planet" src="/assets/images/earth.webp">
        <div class="lights">
        </div>
    </div>
</div>